import React, { useState, useEffect, useRef } from 'react';

import { useAuthContext } from '../../../Auth/AuthProvider';
import { PermissionEnum } from '../../../../types/PermissionEnum';
import { useStoreContext } from '../../../App/StoreProvider';
import { Alert, Dropdown, Table } from 'react-bootstrap';

import { Parser } from '@json2csv/plainjs';
import { useMutation, useQuery } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';
import { Loading, Error, CustomButton } from '../../../_common';
import {
    EditStageSheet,
    GetDetailsForStageSheet,
    GetRecipientDetails,
    GetStageSheet,
    RemoveBox,
    RunOrder,
    RunOrderDetailsType,
    GetStageSheet_getStageSheet_propDetails as ProppantDetails,
    GetStageSheet_getStageSheet_details as StageSheet,
    UpdateBox,
    GetPdf_getPdf as pdfData,
    SendEmail_sendEmail as SendEmailResponse,
    AddStages,
    GetStageDetails_getStageDetails_stageDetails as StageDetails,
    GetJobLogMetaData,
    GetJobLogMetaData_getJobLogMetaData_types as JobLogTypesType,
    GetJobLogMetaData_getJobLogMetaData_issues as JobLogIssueType,
    GetJobLogMetaData_getJobLogMetaData_rootcauses as JobLogRootCauseType,
    GetJobLogMetaData_getJobLogMetaData_locationLOFAs as JobLogLocationLofaType,
    RevertStageSheet,
    UpdateInventoryWeight,
} from '../../../../types/schemaTypes';
import './StageSheet.scss';
import StartStageModal from '../StageSummaryModals/StartStageModal';
import EndStageModal from '../StageSummaryModals/EndStageModal';
import PauseStageModal from '../StageSummaryModals/PauseStageModal';
import ResumeStageModal from '../StageSummaryModals/ResumeStageModal';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

import { ToastContainer, toast } from 'react-toastify';
import { toastOpt } from '../../../../utils/helpers/toastHelper'
import { Link, useParams } from 'react-router-dom';
import { Routes } from '../../../../utils/Routes';
import {
    GET_DETAILS_FOR_STAGE_SHEET,
    GET_STAGE_SHEET,
    GET_RECIPIENT_DETAILS,
    GET_STAGE_DETAILS,
    GET_PDF,
    GET_JOB_LOG_META_DATA,
} from '../../../../graphql/client/queries';
import StageSheetModal from './StageSheetModal';
import {
    EDIT_STAGE_SHEET,
    REMOVE_BOX,
    UPDATE_BOX,
    UPDATE_RUN_ORDER,
    SEND_EMAIL,
    ALLOCATE_PARTIAL,
    END_STAGES,
    PAUSE_STAGES,
    RESUME_STAGES,
    START_STAGES,
    ADD_EDIT_JOB_LOGS,
    REVERT_STAGESHEET,
    UPDATE_BOX_WEIGHT,
    UPDATE_INVENTORY_WEIGHT,
} from '../../../../graphql/client/mutations';

import StageSheetDeleteModal from './StageSheetDeleteModal';
import StageSheetEditMode from './StageSheetEditMode';
import StageSheetWeightEditMode from './StageSheetWeightEditMode';
import SendEmailModal from '../SendEmailModal/SendEmailModal';
import { useReactToPrint } from 'react-to-print';
import { StageSheetPrintAllLayout } from './StageSheetPrintAllLayout';
import { StageSheetPrintForkliftLayout } from './StageSheetPrintForkliftLayout';
import StageSheetPartialModal from './StageSheetPartialModal';
import { NumericFormat as NumberFormat } from 'react-number-format';
import StageSheetRevertMode from './StageSheetRevertMode';
import StageSheetEditLoadWeightModal from './StageSheetEditLoadWeightModal';
import JobMenuItems from '../../../Header/JobMenuItemsHeader/JobMenuItems';
import StageSheetBellyDumpEditMode from './StageSheetBellyDumpEditMode';
import StageSheetBellyDumpRevertMode from './StageSheetBellyDumpRevertMode';
import { StageSheetBellyDumpPrintAllLayout } from './StageSheetBellyDumpPrintAllLayout';

interface WeightDetailsProps {
    stageSheetProppantId: number;
    totalWeight: number;
}

interface StageSheetDetailsProps {
    stageSheetBoxId: number;
    station: number;
    weightRemaining: number;
}

interface StageToEditProps {
    weightDetails: WeightDetailsProps[];
    stageSheetDetails: StageSheetDetailsProps[];
}

interface StageToRevertProps {
    stageSheetBoxId: number;
    loadId: number;
    weight: number;
    weightRemaining: number;
}

const StageSheetBellyDump = ({ match }: any): React.ReactElement => {
    const authContext = useAuthContext();
    const isDisplayLoadsEnabled = authContext.userHasPermission(PermissionEnum.ViewLoads);
    const isViewStageSheetEnabled = authContext.userHasPermission(PermissionEnum.ViewStageSheet);
    const isUpdateRunOrderEnabled = authContext.userHasPermission(PermissionEnum.UpdateRunOrder);
    const isSendEmailEnabled = authContext.userHasPermission(PermissionEnum.SendEmail);
    const isPrintForkliftOpEnabled = authContext.userHasPermission(PermissionEnum.PrintForkliftOp);
    const isPrintAllEnabled = authContext.userHasPermission(PermissionEnum.PrintAll);
    const isEditStageSheetEnabled = authContext.userHasPermission(PermissionEnum.EditStageSheet);
    const isRevertStageSheetEnabled = authContext.userHasPermission(PermissionEnum.RevertStageSheet);
    const isStartEndStageEnabled = authContext.userHasPermission(PermissionEnum.StartEndStage);
    const isPauseResumeStageEnabled = authContext.userHasPermission(PermissionEnum.PauseResumeStage);
    const isAddBoxesEnabled = authContext.userHasPermission(PermissionEnum.AddBoxes);
    const isDownloadEnabled = authContext.userHasPermission(PermissionEnum.Download);
    const isUpdateBoxesEnabled = authContext.userHasPermission(PermissionEnum.UpdateBoxes);

    const [state, dispatch] = useStoreContext();

    const [tabTitle, setTabTitle] = useState(document.title);
    const [jobIdForEmail, setJobIdForEmail] = useState(-1);
    document.title = localStorage.getItem('Jobdetails-TabName') + tabTitle;
    const abortController = new AbortController();
    //const [showDownloadFilter, setShowDownloadFilter] = useState(false);

    const printForkliftcomponentRef = useRef(null);
    const printAllBellyDumpComponentRef = useRef(null);
    const handlePrintForklift = useReactToPrint({ contentRef: printForkliftcomponentRef });
    const handlePrintAll = useReactToPrint({ contentRef: printAllBellyDumpComponentRef });

    let jobId = 0;
    let jobName: string | null = '';
    document.title = jobName;
    let wellheadStages: string | null = '';

    const [isRunOrderDisabled, setIsRunOrderDisabled] = useState(true);
    const [isDragDisabled, setIsDragDisabled] = useState(false);
    const [runOrderDetails, setRunOrderDetails] = useState<RunOrderDetailsType[]>([]);

    const [isWeightEdit, setIsWeightEdit] = useState(false);
    const [isStageSheetEdit, setIsStageSheetEdit] = useState(false);
    const [showStartStageModal, setShowStartStageModal] = useState(false);
    const [stageSheets, setStageSheets] = useState<StageSheet[]>([]);

    const [stagesToEdit, setStagesToEdit] = useState<StageToEditProps>({
        weightDetails: [],
        stageSheetDetails: [],
    });

    const [isRevertMode, setIsRevertMode] = useState(false);
    const [stagesToRevert, setStagesToRevert] = useState<StageToRevertProps[]>([]);

    const [showEditLoadWeightModal, setShowEditLoadWeightModal] = useState(false);
    const [stageSheetToEditWeight, setStageSheetToEditWeight] = useState<StageSheet | undefined>();

    const [weightInvalidErrorList, setWeightInvalidErrorList] = useState<number[]>([]);
    const [weightZeroErrorList, setWeightZeroErrorList] = useState<number[]>([]);
    const [weightRemainingInvalidErrorList, setWeightRemainingInvalidErrorList] = useState<number[]>([]);
    const [weightRemainingErrorList, setWeightRemainingErrorList] = useState<number[]>([]);

    const [showStageSheetModal, setShowStageSheetModal] = useState(false);
    const [sendEmailMsg, setSendEmailMsg] = useState('');
    const [showSendEmailModal, setShowSendEmailModal] = useState(false);
    const [modalType, setModalType] = useState('');
    const [isPartial, setIsPartial] = useState(false);
    const [showStageSheetDeleteModal, setShowStageSheetDeleteModal] = useState(false);
    const [boxForPartial, setBoxForPartial] = useState<StageSheet>();
    const [showStageSheetPartialModal, setShowStageSheetPartialModal] = useState(false);
    const [stageSheetBoxId, setStageSheetBoxId] = useState(0);
    const [stageSheetBox, setStageSheetBox] = useState('');
    const [proppantId, setProppantId] = useState(0);
    const [sandTicket, setSandTicket] = useState('');
    const [boxWeight, setBoxWeight] = useState(0);
    const [sandTicketNumber, setSandTicketNumber] = useState('');
    const [stageMsgNumbers, setStageMsgNumbers] = useState('');
    const [stageModalError, setStageModalError] = useState('');
    const [modalError, setModalError] = useState('');
    const [isInProcessJobStatus, setIsInProcessJobStatus] = useState(false);
    const [showEndStageModal, setShowEndStageModal] = useState(false);
    const [showEndButton, setShowEndButton] = useState(false);
    const [showResumeButton, setShowResumeButton] = useState(false);
    const [showStartButton, setShowStartButton] = useState(false);
    const [showPauseButton, setShowPauseButton] = useState(false);
    const [showPauseStageModal, setShowPauseStageModal] = useState(false);
    const [showResumeStageModal, setShowResumeStageModal] = useState(false);
    const toasterOptions = { duration: 2500 };
    const { stageSheetId } = useParams()
    const stageSheetIdVal: any = stageSheetId
    const toastMessages = {
        startStage: `Stages started sucessfully`,
        endStage: `Stages ended sucessfully`,
        pauseStage: `Stages paused sucessfully`,
        resumeStage: `Stages resumed sucessfully`,
        revert: `Stages edited sucessfully`,
        revertError: `Stages could not be edited `,
    };

    const { loading: detailsLoading, error: detailsError, data: details } = useQuery<GetDetailsForStageSheet>(GET_DETAILS_FOR_STAGE_SHEET, {
        variables: {
            stageSheetId: parseInt(stageSheetIdVal),
        },
        fetchPolicy: 'network-only',
    });

    const { loading: recipientDetailsLoading, error: recipientDetailsError, data: recipientDetailsData } = useQuery<GetRecipientDetails>(
        GET_RECIPIENT_DETAILS,
        {
            variables: {
                jobId: jobIdForEmail,
                notificationType: 'StageSheetEmails',
            },
            fetchPolicy: 'network-only',
            skip: jobIdForEmail === -1,
        },
    );

    let stageStatusData: any;
    let stageNumbers = '';
    let showRevert = true;
    if (details && details.getDetailsForStageSheet) {
        jobIdForEmail === -1 && (setJobIdForEmail(details.getDetailsForStageSheet.jobId));
        stageStatusData = details.getDetailsForStageSheet;
        const tempStageNumbers = (details.getDetailsForStageSheet.stageStatus ?? [])
            .filter((s): s is NonNullable<typeof s> => s != null)
            .map(s => s.stageId);
        const msgForIds = details.getDetailsForStageSheet.wellheadStages;
        stageNumbers = tempStageNumbers.join(',');
        stageMsgNumbers.length === 0 && (setStageMsgNumbers((msgForIds?.split('OF') ?? [])[0]?.replace('STAGE', '') ?? ''));

        const stageStatus = (details.getDetailsForStageSheet.stageStatus ?? [])
            .filter((s): s is NonNullable<typeof s> => s != null)
            .map(s => s.status);
        if (stageStatus.some(s => s == 'Running' || s == 'Paused')) {
            !showEndButton && (setShowEndButton(true));
        } else {
            showEndButton && (setShowEndButton(false));
        }

        if (stageStatus.some(s => s == 'Paused')) {
            !showResumeButton && (setShowResumeButton(true));
        } else {
            showResumeButton && (setShowResumeButton(false));
        }

        if (stageStatus.some(s => s == 'Running')) {
            !showPauseButton && (setShowPauseButton(true));
        } else {
            showPauseButton && (setShowPauseButton(false));
        }

        if (stageStatus.some(s => s == 'Preparing')) {
            showRevert = false;
            !showStartButton && (setShowStartButton(true));
        } else {
            showStartButton && (setShowStartButton(false));
        }
    }

    if (details && details.getDetailsForStageSheet) {
        jobId = details.getDetailsForStageSheet.jobId;
        jobName = details.getDetailsForStageSheet.wellName;
        wellheadStages = details.getDetailsForStageSheet.wellheadStages;
        document.title = jobName ?? tabTitle;
    }
    //Sundeep
    const { loading: stageSheetLoading, error: stageSheetError, data: stageSheetData } = useQuery<GetStageSheet>(GET_STAGE_SHEET, {
        variables: {
            stageSheetId: parseInt(stageSheetIdVal),
        },
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (stageSheetData && stageSheetData.getStageSheet) {
            setStageSheets([]);
        }
    }, [stageSheetData]);// [stageSheetData.getStageSheet]); --comeback

    let proppantDetails: ProppantDetails[] = [];
    if (stageSheetData?.getStageSheet) {
        proppantDetails = (stageSheetData.getStageSheet.propDetails ?? []).filter((p): p is ProppantDetails => p != null);
        if (stageSheets.length === 0) {
            const tempStageSheets = (stageSheetData.getStageSheet.details ?? []).filter((d): d is StageSheet => d != null);
            if (tempStageSheets.length !== 0) setStageSheets(tempStageSheets);
        }
    }

    const { loading: jobLogsMetaDataLoading, error: jobLogsMetaDataError, data: jobLogsMetaData } = useQuery<
        GetJobLogMetaData
    >(GET_JOB_LOG_META_DATA, {
        variables: {
            jobId: jobId,
        },
        fetchPolicy: 'network-only',
        skip: jobId === 0,
    });

    const jobLogsTypesData: JobLogTypesType[] = [];
    const jobLogsIssuesData: JobLogIssueType[] = [];
    const jobLogsRootCausesData: JobLogRootCauseType[] = [];
    const jobLogsLocationLofaData: JobLogLocationLofaType[] = [];
    if (jobLogsMetaData && jobLogsMetaData.getJobLogMetaData) {
        if (jobLogsMetaData.getJobLogMetaData.types)
            jobLogsMetaData.getJobLogMetaData.types.map(jobLogType => {
                if (jobLogType) jobLogsTypesData.push(jobLogType);
            });
        if (jobLogsMetaData.getJobLogMetaData.issues)
            jobLogsMetaData.getJobLogMetaData.issues.map(jobLogIssue => {
                if (jobLogIssue) jobLogsIssuesData.push(jobLogIssue);
            });
        if (jobLogsMetaData.getJobLogMetaData.rootcauses)
            jobLogsMetaData.getJobLogMetaData.rootcauses.map(jobLogRootCauses => {
                if (jobLogRootCauses) jobLogsRootCausesData.push(jobLogRootCauses);
            });
        if (jobLogsMetaData.getJobLogMetaData.locationLOFAs)
            jobLogsMetaData.getJobLogMetaData.locationLOFAs.map(jobLogLocationLofa => {
                if (jobLogLocationLofa) jobLogsLocationLofaData.push(jobLogLocationLofa);
            });
    }

    const handleOnCloseModal = () => {
        setModalError('');
        setModalType('');
        setShowStageSheetModal(false);
        setShowStageSheetDeleteModal(false);
        setStageSheetBoxId(0);
        setStageSheetBox('');
        setProppantId(0);
        setSandTicket(sandTicket);
        setSandTicketNumber(sandTicket);
    };
    const handleOnCloseEmailModal = () => {
        setShowSendEmailModal(false);
    };

    const [runOrder, { loading: runOrderLoading }] = useMutation<RunOrder>(UPDATE_RUN_ORDER, {
        onCompleted: () => setIsRunOrderDisabled(true),
        refetchQueries: [
            {
                query: GET_DETAILS_FOR_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
            {
                query: GET_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
        ],
    });

    const [updateBox, { loading: mutationLoading }] = useMutation<UpdateBox>(UPDATE_BOX, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setModalError(error.message ?? error);
            }
        },
        onCompleted: () => {
            setRunOrderDetails([]);
            setIsRunOrderDisabled(true);
            handleOnCloseModal();
        },
        refetchQueries: [
            {
                query: GET_DETAILS_FOR_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
            {
                query: GET_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
        ],
    });

    const handleOnClickPartial = stageSheet => {
        setBoxForPartial(stageSheet);
        setShowStageSheetPartialModal(true);
    };
    const handleOnClosePartialModal = () => {
        setShowStageSheetPartialModal(false);
    };
    const [allocatePartial, { loading: allocatePartialLoading }] = useMutation(ALLOCATE_PARTIAL, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setModalError(error.message ?? error);
            }
        },
        onCompleted: () => {
            handleOnClosePartialModal();
        },
        refetchQueries: [
            {
                query: GET_DETAILS_FOR_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
            {
                query: GET_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
        ],
    });

    const [sendEmailInput, { loading: mutationSendEmailLoading }] = useMutation<SendEmailResponse>(SEND_EMAIL, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setModalError(error.message ?? error);
            }
            setSendEmailMsg(error.message);
            setShowSendEmailModal(true);
        },
        onCompleted: () => {
            setSendEmailMsg('Email has been sent to the recipients');
            setShowSendEmailModal(true);
        },
    });

    const handleOnClickEditWeight = () => {
        setIsWeightEdit(true);
        setIsDragDisabled(true);
        setRunOrderDetails([]);
        setIsRunOrderDisabled(true);
    };

    const handleOnClickEdit = () => {
        setIsStageSheetEdit(true);
        setIsDragDisabled(true);
        setRunOrderDetails([]);
        setIsRunOrderDisabled(true);
    };

    const handleOnClickCancelEdit = () => {
        setStagesToEdit({
            weightDetails: [],
            stageSheetDetails: [],
        });
        setIsStageSheetEdit(false);
        setIsWeightEdit(false);
        setIsDragDisabled(false);
    };

    const [editStageSheet, { loading: editStageSheetLoading }] = useMutation<EditStageSheet>(EDIT_STAGE_SHEET, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setModalError(error.message ?? error);
            }
        },
        onCompleted: () => handleOnClickCancelEdit(),
        refetchQueries: [
            {
                query: GET_DETAILS_FOR_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
            {
                query: GET_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
        ],
    });

    const [deleteBox, { loading: deleteMutationLoading }] = useMutation<RemoveBox>(REMOVE_BOX, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setModalError(error.message ?? error);
            }
        },
        onCompleted: () => {
            setRunOrderDetails([]);
            setIsRunOrderDisabled(true);
            handleOnCloseModal();
        },
        refetchQueries: [
            {
                query: GET_DETAILS_FOR_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
            {
                query: GET_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
        ],
    });

    const handleOnClickEditLoadWeight = stageSheet => {
        setStageSheetToEditWeight(stageSheet);
        setShowEditLoadWeightModal(true);
    };
    const handleOnClickCancelEditLoadWeight = () => {
        setStageModalError('');
        setShowEditLoadWeightModal(false);
        setStageSheetToEditWeight(undefined);
    };

    const [updateInventoryWeight, { loading: updateInventoryWeightLoading }] = useMutation<UpdateInventoryWeight>(
        UPDATE_INVENTORY_WEIGHT,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
                } else {
                    setStageModalError(error.message ?? error);
                }
            },
        },
    );

    const [updateBoxWeight, { loading: updateBoxWeightLoading }] = useMutation<UpdateBox>(UPDATE_BOX_WEIGHT, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {

                setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setStageModalError(error.message ?? error);
            }
        },
        onCompleted: () => {
            handleOnClickCancelEditLoadWeight();
        },
        refetchQueries: [
            {
                query: GET_DETAILS_FOR_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
            {
                query: GET_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
        ],
    });

    const handleOnClickUpdateRunOrder = async () => {
        if (!isRunOrderDisabled && !isDragDisabled) {
            setIsRunOrderDisabled(true);
            await runOrder({
                variables: {
                    input: {
                        runOrderDetails: runOrderDetails,
                    },
                },
            });
        }
    };

    const handleOnSaveEdit = async () => {
        await editStageSheet({
            variables: {
                input: {
                    stageSheetDetails: stagesToEdit.stageSheetDetails,
                    weightDetails: stagesToEdit.weightDetails,
                },
            },
        });
    };

    const handleOnClickButton = (modalType, stageSheetBox, stageSheetBoxId, boxWeight, isPartial) => {
        setModalType(modalType);
        setStageSheetBoxId(stageSheetBoxId);
        setStageSheetBox(stageSheetBox);
        setBoxWeight(boxWeight);
        setShowStageSheetModal(true);
        setIsPartial(isPartial);
    };

    const handleOnClickDeleteButton = (stageSheetBoxId, stageSheetBox, proppantId) => {
        setStageSheetBoxId(stageSheetBoxId);
        setStageSheetBox(stageSheetBox);
        setProppantId(proppantId);
        setShowStageSheetDeleteModal(true);
    };

    const handleOnClickSandTicket = (sandTicket, sandTicketNumber) => {
        setSandTicket(sandTicket);
        setSandTicketNumber(sandTicketNumber);
        setModalType('sandTicket');
        setShowStageSheetModal(true);
    };

    const handleOnSave = async (stageSheetBoxId: number, command: string, weightRemaining: number) => {
        await updateBox({
            variables: {
                input: {
                    command: command,
                    stageSheetBoxId: stageSheetBoxId,
                    weightRemaining: weightRemaining,
                },
            },
        });
    };

    const handleOnClickDelete = async (stageSheetBoxId: number) => {
        await deleteBox({
            variables: {
                input: {
                    stageSheetBoxId: stageSheetBoxId,
                },
            },
        });
    };

    const handleDragEnd = results => {
        if (!results.source || !results.destination) {
            return;
        }
        setIsRunOrderDisabled(false);
        const stageSheetCopy = [...stageSheets];
        const [selectedData] = stageSheetCopy.splice(results.source.index, 1);

        stageSheetCopy.splice(results.destination.index, 0, selectedData);


        const tempRunOrderDetails: RunOrderDetailsType[] = [];
        for (const stageSheet in stageSheetCopy) {
            tempRunOrderDetails.push({
                stageSheetBoxId: stageSheetCopy[stageSheet].stageSheetBoxId,
                runOrder: parseInt(stageSheet) + 1,
            });
        }
        setRunOrderDetails(tempRunOrderDetails);
        setStageSheets(stageSheetCopy);
    };

    const sendEmailHandler = async () => {
        const recipientDetailsList =
            recipientDetailsData?.getRecipientDetails?.recipientDetails?.filter(
                (item): item is NonNullable<typeof item> => item != null,
            ) ?? [];

        if (recipientDetailsList.length > 0) {
            const stageSheetEmailsExtEmail = recipientDetailsList
                .filter(function (item) {
                    return item?.alertType === 'StageSheetEmails';
                })
                .map(a => a?.email);

            if (stageSheetEmailsExtEmail.length > 0) {
                await sendEmailInput({
                    variables: {
                        input: {
                            stageSheetId: parseInt(stageSheetIdVal),
                            jobName: jobName,
                            wellHeadDetails: wellheadStages,
                            fileName: wellheadStages?.split('OF')[0],
                            jobId: parseInt(String(details?.getDetailsForStageSheet?.jobId ?? 0), 10),
                            emailrecipients: stageSheetEmailsExtEmail.join(','),
                        },
                    },
                });
            } else {
                setSendEmailMsg('Email could not be sent as recipients were not configured.');
                setShowSendEmailModal(true);
            }
        } else {
            setSendEmailMsg('Email could not be sent as recipients were not configured.');
            setShowSendEmailModal(true);
        }
    };

    const downloadFileHandler = () => {
        const stageSheetDetails: StageSheet[] = (stageSheetData?.getStageSheet?.details ?? []).filter(
            (d): d is StageSheet => d != null
        );
        if (stageSheetDetails.length !== 0) {
            const stageSheetDetailsList = stageSheetDetails.map(stageSheetDetail => {
                if (stageSheetDetail.station == '0') {
                    const stageSheetDetailMirror = { ...stageSheetDetail }
                    stageSheetDetailMirror.station = '';
                    stageSheetDetail = { ...stageSheetDetailMirror }
                }
                const record = {
                    'Station#': stageSheetDetail.station,
                    Box: stageSheetDetail.boxDesc ?? '',
                    Weight: stageSheetDetail.boxWeight ?? '',
                    'Accumulated Weight': stageSheetDetail.accumulatedWeight ?? '',
                    Type: stageSheetDetail.proppant ?? '',
                    'Pad Location': stageSheetDetail.location ?? '',
                    'Wt. Remaining': stageSheetDetail.boxWeightRemaining ?? '',
                    OOS: stageSheetDetail.isOOS ? 'Yes' : 'No',
                    'PO #': (stageSheetDetail.sandPo ?? '') + '\t',
                    'Origin #': (stageSheetDetail.lofaOrigin ?? '') + '\t',
                };

                if (!stageSheetDetail.stageSheetBellyDump || stageSheetDetail.stageSheetBellyDump.length === 0) {
                    record['Ticket #'] = (stageSheetDetail.sandTicket ?? '') + '\t';
                    record['Load#'] = String(stageSheetDetail.loadId ?? '') + '\t';
                }

                if (stageSheetDetail.stageSheetBellyDump && stageSheetDetail.stageSheetBellyDump.length > 0) {
                    stageSheetDetail.stageSheetBellyDump.forEach((load, index) => {
                        record[`Load #${index + 1}`] = load?.loadId + '\t';
                        record[`Ticket #${index + 1}`] = load?.sandTicket + '\t';
                        record[`Weight #${index + 1}`] = load?.sandTicketWeight + '\t';
                        record[`Weight Remaining #${index + 1}`] = load?.sandTicketWeightRemaining + '\t';
                    });
                }


                return record;
            });

            const opts = {};
            const parser = new Parser(opts);
            const csvData = parser.parse(stageSheetDetailsList);
            const file = new Blob([csvData], { type: 'application/csv' });
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Stage Sheet.csv`;
            a.click();
        }
    };
    const handleOnCloseStageModal = (modalType: string) => {
        setStageModalError('');

        modalType === 'startStage' && (setShowStartStageModal(false));
        modalType === 'endStage' && (setShowEndStageModal(false));
        modalType === 'pauseStage' && (setShowPauseStageModal(false));
        modalType === 'resumeStage' && (setShowResumeStageModal(false));
    };

    const renderToast = (message, type = 'info') => {
        interface ToastProps {
            onClose?: () => void;
        }
        const Comp = (props: ToastProps) => {
            return (
                <Alert variant={type} onClose={props.onClose}>
                    {message}
                </Alert>
            );
        };
        Comp.displayName = 'toast';
        return Comp;
    };
    const handleOnComplete = (modalType: string) => {
        handleOnCloseStageModal(modalType);
        toast.success(toastMessages[modalType], toastOpt);
    };

    const [addEditJobLog, { loading: addEditJobLogLoading }] = useMutation(ADD_EDIT_JOB_LOGS, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setStageModalError(error.message ?? error);
            }
        },
    });
    const [pauseStages, { loading: pauseStagesLoading, error: pauseStagesError }] = useMutation<AddStages>(
        PAUSE_STAGES,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
                } else {
                    setStageModalError(error.message ?? error);
                }
            },
            onCompleted: () => handleOnComplete('pauseStage'),
            refetchQueries: [
                {
                    query: GET_DETAILS_FOR_STAGE_SHEET,
                    variables: {
                        stageSheetId: parseInt(stageSheetIdVal),
                    },
                },
                {
                    query: GET_STAGE_SHEET,
                    variables: {
                        stageSheetId: parseInt(stageSheetIdVal),
                    },
                },
            ],
        },
    );
    const [resumeStages, { loading: resumeStagesLoading, error: resumeStagesError }] = useMutation<AddStages>(
        RESUME_STAGES,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    const serverErrorWithComa = error.errors[0]?.message?.toString().replace(',', ' ') || error.message;
                    const errorMsg = serverErrorWithComa.split('|');
                    setStageModalError(errorMsg.join(','));
                    //setStageModalError(error.graphQLErrors[0].message.toString().replace(',', ' '));
                } else {
                    setStageModalError(error.message ?? error);
                }
            },
            onCompleted: () => handleOnComplete('resumeStage'),
            refetchQueries: [
                {
                    query: GET_DETAILS_FOR_STAGE_SHEET,
                    variables: {
                        stageSheetId: parseInt(stageSheetIdVal),
                    },
                },
                {
                    query: GET_STAGE_SHEET,
                    variables: {
                        stageSheetId: parseInt(stageSheetIdVal),
                    },
                },
            ],
        },
    );
    const [startStages, { loading: startStagesLoading, error: startStagesError }] = useMutation<AddStages>(
        START_STAGES,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    const serverErrorWithComa = error.errors[0]?.message?.toString().replace(',', ' ') || error.message;
                    const errorMsg = serverErrorWithComa.split('|');
                    setStageModalError(errorMsg.join(','));
                } else {
                    setStageModalError(error.message ?? error);
                }
            },
            onCompleted: () => handleOnComplete('startStage'),
            refetchQueries: [
                {
                    query: GET_DETAILS_FOR_STAGE_SHEET,
                    variables: {
                        stageSheetId: parseInt(stageSheetIdVal),
                    },
                },
                {
                    query: GET_STAGE_SHEET,
                    variables: {
                        stageSheetId: parseInt(stageSheetIdVal),
                    },
                },
            ],
        },
    );
    const [endStages, { loading: endStagesLoading, error: endStagesError }] = useMutation<AddStages>(END_STAGES, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setStageModalError(error.message ?? error);
            }
        },
        onCompleted: () => {
            handleOnComplete('endStage');
            window.location.href = `${Routes.STAGE_SUMMARY.route}${jobId}`;
        },
        refetchQueries: [
            {
                query: GET_DETAILS_FOR_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
            {
                query: GET_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
        ],
    });

    const handleOnCompleteRevert = () => {
        setIsRevertMode(false);
        setStagesToRevert([]);
        toast.success(toastMessages.revert, toastOpt);


    };
    const [revertStageSheet, { loading: revertStageSheetLoading }] = useMutation<RevertStageSheet>(REVERT_STAGESHEET, {
        onCompleted: () => handleOnCompleteRevert(),
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                toast.error(toastMessages.revertError + (error.errors[0]?.message?.toString().replace(',', ' ') || error.message), toastOpt);

            } else {
                toast.error(toastMessages.revertError + (error.message ?? String(error)), toastOpt);

            }
        },
        refetchQueries: [
            {
                query: GET_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
        ],
    });

    const handleOnEndStages = async (jobStageIds: number[], comments) => {
        await endStages({
            variables: {
                input: {
                    stageIds: jobStageIds,
                    comments: comments,
                    fromStageSheet: true,
                },
            },
        });
    };

    const handleOnStartStages = async (stageNubers, jobId) => {
        await startStages({
            variables: {
                input: {
                    stageIds: stageNubers.split(',').map(Number),
                    jobId: parseInt(jobId),
                    fromStageSheet: true,
                },
            },
        });
    };

    const handleOnPauseStages = async (
        jobStageIds,
        jobLogId,
        jobLogTypeId,
        jobLogIssueId,
        startDate,
        endDate,
        estimatedDowntime,
        loadId,
        notes,
        locationLofa,
        amount,
        rootCauseId,
        correctiveAction,
    ) => {
        const result = await pauseStages({
            variables: {
                input: {
                    stageIds: jobStageIds,
                },
            },
        });

        if (result && result['data'] && result['data']['pauseStages']['errors'].length === 0) {
            jobStageIds.map(async jobStageId => {
                await addEditJobLog({
                    variables: {
                        input: {
                            jobLogId: jobLogId,
                            jobLogIssueId: jobLogIssueId,
                            jobLogTypeId: jobLogTypeId,
                            jobId: jobId,
                            startDate: startDate,
                            endDate: endDate,
                            estimatedDowntime: estimatedDowntime,
                            jobStageId: jobStageId,
                            loadId: loadId,
                            notes: notes,
                            locationLofa: locationLofa,
                            amount: amount,
                            rootCauseId: rootCauseId,
                            correctiveAction: correctiveAction,
                        },
                    },
                });
            });
        }
    };

    const handleOnResumeStages = async jobStageIds => {
        await resumeStages({
            variables: {
                input: {
                    stageIds: jobStageIds,
                    jobId: jobId,
                },
            },
        });
    };

    const handleOnSavePartialModal = boxList => {
        const partialBoxDetails: Record<string, unknown>[] = [];
        boxList.map(box => {
            partialBoxDetails.push({
                stageSheetBoxId: box.stageSheetBoxId,
                boxDesc: parseInt(box.boxDesc),
                proppantId: box.proppantId,
                stageSheetId: box.stageSheetId,
                splitWeight: box.splitWeight,
            });
        });
        allocatePartial({
            variables: {
                input: {
                    partialBoxDetails: partialBoxDetails,
                },
            },
        });
    };

    const handleOnClickRevert = () => {
        setIsRevertMode(true);
    };

    const handleOnClickCancelRevert = () => {
        setIsRevertMode(false);
        setStagesToRevert([]);
        setWeightInvalidErrorList([]);
        setWeightZeroErrorList([]);
        setWeightRemainingInvalidErrorList([]);
        setWeightRemainingErrorList([]);
    };

    const handleOnSaveRevert = () => {
        const tempWeightInvalidErrorList: number[] = [];
        const tempWeightZeroErrorList: number[] = [];
        const tempWeightRemainingInvalidErrorList: number[] = [];
        const tempWeightRemainingErrorList: number[] = [];

        if (stagesToRevert.length !== 0) {
            let isError = false;
            stagesToRevert.map(stageToRevert => {
                if (isNaN(stageToRevert.weight)) {
                    isError = true;
                    tempWeightInvalidErrorList.push(stageToRevert.stageSheetBoxId);
                }
                if (stageToRevert.weight === 0) {
                    isError = true;
                    tempWeightZeroErrorList.push(stageToRevert.stageSheetBoxId);
                }
                if (isNaN(stageToRevert.weightRemaining)) {
                    isError = true;
                    tempWeightRemainingInvalidErrorList.push(stageToRevert.stageSheetBoxId);
                }
                if (stageToRevert.weightRemaining > stageToRevert.weight) {
                    isError = true;
                    tempWeightRemainingErrorList.push(stageToRevert.stageSheetBoxId);
                }
            });

            setWeightInvalidErrorList(tempWeightInvalidErrorList);
            setWeightZeroErrorList(tempWeightZeroErrorList);
            setWeightRemainingInvalidErrorList(tempWeightRemainingInvalidErrorList);
            setWeightRemainingErrorList(tempWeightRemainingErrorList);

            if (!isError)
                revertStageSheet({
                    variables: {
                        input: {
                            stageSheetDetails: stagesToRevert,
                            jobStatus: 'Running',
                        },
                    },
                });
        }
    };

    const handleOnSaveEditLoadWeight = async (boxId, loadId, inventoryWeight, oldInventoryWeight, stageSheetBoxId) => {
        const result = await updateInventoryWeight({
            variables: {
                input: {
                    boxId: boxId,
                    loadId: loadId,
                    inventoryWeight: inventoryWeight,
                },
            },
        });

        if (result && result['data'] && result['data']['updateInventoryWeight'] && result['data']['updateInventoryWeight']['errors'] && result['data']['updateInventoryWeight']['errors'].length === 0) {
            await updateBoxWeight({
                variables: {
                    input: {
                        boxId: boxId,
                        loadId: loadId,
                        inventoryWeight: inventoryWeight,
                        oldInventoryWeight: oldInventoryWeight,
                        stageSheetBoxId: stageSheetBoxId,
                    },
                },
            });
        }
    };

    if (!isViewStageSheetEnabled) {
        return (
            <div className="StageSummary-Container">
                <ToastContainer />
                <div className="StageSummary-Header-Container">
                    <div className="StageSummary-Header">Stage Summary: {jobName}</div>
                    <div style={{ width: 250 }}></div>

                    <JobMenuItems jobId={jobId.toString()} menu='stageSummary'/>
                </div>

                <div className="NoResult-Container StageSummary-Unauth-Container">
                    <div className="NoResult-First-Title-Secondary">Unauthorized</div>
                    <div className="NoResult-First-Title-Primary">You do not have permission to view this screen</div>
                </div>
            </div>
        );
    }

    return (

        <div className="Messages-Container">
            <ToastContainer />
            <div className="StageSheet-Header-Container">
                <div className="StageSheet-Header">Stage Sheet: {jobName}</div>
                {detailsLoading && (
                    <div className="StageSheet-Header-Loading">
                        <Loading />
                    </div>
                )}

                <JobMenuItems jobId={jobId.toString()} menu='stageSummary'/>
            </div>

            <div className="StageSheet-Subheader-Container">
                <Link
                    to={{
                        pathname: `${Routes.STAGE_SUMMARY.route}${jobId}`,
                    }}
                    className="StageSheet-Back-Button"
                >
                    Back
                </Link>

                {/* For Laptop */}
                <div className="StageSheet-Button-Container">
                    {isAddBoxesEnabled && (
                        <Link
                            to={{
                                pathname: `${Routes.ADD_BOXES.route}${jobId}/${parseInt(stageSheetIdVal)}`,
                            }}
                            className="StageSheet-Button"
                        >
                            <i className="material-icons StageSheet-Icons">add_box</i>
                            Add Boxes
                        </Link>
                    )}
                    {isUpdateRunOrderEnabled && (
                        <button
                            className={`StageSheet-Button ${isRunOrderDisabled && 'StageSheet-Button-Disabled'}`}
                            onClick={() => handleOnClickUpdateRunOrder()}
                        >
                            <i className="material-icons StageSheet-Icons">update</i>
                            Update Run Order
                        </button>
                    )}

                    {isPrintForkliftOpEnabled && (
                        <button className="StageSheet-Button" onClick={handlePrintForklift}>
                            <i className="material-icons StageSheet-Icons">print</i>
                            Print Forklift Op
                        </button>
                    )}
                    {isPrintAllEnabled && (
                        <button className="StageSheet-Button" onClick={handlePrintAll}>
                            <i className="material-icons StageSheet-Icons">print</i>
                            Print All
                        </button>
                    )}
                    {isDownloadEnabled && (
                        <button className="StageSheet-Button" onClick={downloadFileHandler}>
                            <i className="material-icons StageSheet-Icons">get_app</i>
                            Download
                        </button>
                    )}
                    {isSendEmailEnabled && (
                        <button className="StageSheet-Button" onClick={sendEmailHandler}>
                            <i className="material-icons StageSheet-Icons">mail</i>
                            Send Email
                        </button>
                    )}
                </div>

                {/* For Tab */}
                <div className="StageSheet-Button-Container-For-Tab">
                    <Dropdown className="JobProfile-CenterToggleButton-Container">
                        <Dropdown.Toggle
                            variant="link"
                            id="dropdown-basic"
                            className="JobProfile-CenterToggleButton JobProfile-CenterToggleButton-Container common-Actions"
                        >
                            <span>Actions</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item>
                                {isAddBoxesEnabled && (
                                    <Link
                                        to={{
                                            pathname: `${Routes.ADD_BOXES.route}${jobId}/${parseInt(
                                                stageSheetIdVal,
                                            )}`,
                                        }}
                                        className="StageSheet-Dropdown-Button add-box-button"
                                    >
                                        <i className="material-icons StageSheet-Icons">add_box</i>
                                        Add Boxes
                                    </Link>
                                )}
                            </Dropdown.Item>
                            <Dropdown.Item>
                                {isUpdateRunOrderEnabled && (
                                    <button
                                        className={`StageSheet-Dropdown-Button ${isRunOrderDisabled &&
                                            'StageSheet-Button-Disabled'}`}
                                        onClick={() => handleOnClickUpdateRunOrder()}
                                    >
                                        <i className="material-icons StageSheet-Icons">update</i>
                                        Update RunOrder
                                    </button>
                                )}
                            </Dropdown.Item>
                            <Dropdown.Item>
                                {isPrintForkliftOpEnabled && (
                                    <button className="StageSheet-Dropdown-Button" onClick={handlePrintForklift}>
                                        <i className="material-icons StageSheet-Icons">print</i>
                                        Print Forklift Op
                                    </button>
                                )}
                            </Dropdown.Item>
                            <Dropdown.Item>
                                {isPrintAllEnabled && (
                                    <button className="StageSheet-Dropdown-Button" onClick={handlePrintAll}>
                                        <i className="material-icons StageSheet-Icons">print</i>
                                        Print All
                                    </button>
                                )}
                            </Dropdown.Item>
                            <Dropdown.Item>
                                {isDownloadEnabled && (
                                    <button className="StageSheet-Dropdown-Button" onClick={downloadFileHandler}>
                                        <i className="material-icons StageSheet-Icons">get_app</i>
                                        Download
                                    </button>
                                )}
                            </Dropdown.Item>
                            <Dropdown.Item>
                                {isSendEmailEnabled && (
                                    <button className="StageSheet-Dropdown-Button" onClick={sendEmailHandler}>
                                        <i className="material-icons StageSheet-Icons">mail</i>
                                        Send Email
                                    </button>
                                )}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>

            <div className="StageSheet-Stages">{wellheadStages}</div>

            {isEditStageSheetEnabled && (
                <div className="StageSheet-Weight-Edit-Container">
                    {!isWeightEdit ? (
                        proppantDetails.length !== 0 &&
                        !isStageSheetEdit &&
                        !isRevertMode && (
                            <div className="StageSheet-Edit-Button" onClick={() => handleOnClickEditWeight()}>
                                <i className="material-icons StageSheet-Edit-Icon">edit</i>
                                Edit
                            </div>
                        )
                    ) : (
                        <div className="StageSheet-Cancel-Save-Button">
                            <CustomButton title="Cancel" isBordered onClick={() => handleOnClickCancelEdit()} />
                            <div className="StageSheet-Save-Button">
                                <CustomButton
                                    title="Save"
                                    onClick={() => {
                                        handleOnSaveEdit();
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}

            <div className="StageSheet-Grid-Container">
                <Table striped bordered className="tabletest StageSheet-Proppant-Details-Grid">
                    <thead>
                        <tr>
                            <th className="StageSheet-Grid-Header">Proppant</th>
                            <th className="StageSheet-Grid-Header">Total Weight Needed</th>
                            <th className="StageSheet-Grid-Header">Sand Pumped</th>
                            <th className="StageSheet-Grid-Header">Cumulative Box Weight</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(stageSheetLoading || runOrderLoading || editStageSheetLoading || revertStageSheetLoading) && (
                            <div className="StageSheet-ProppantDetails-Spinner-Container">
                                <Loading />
                            </div>
                        )}

                        {!stageSheetLoading && proppantDetails.length === 0 ? (
                            <tr>
                                <td colSpan={4}>
                                    <div className="NoResult-Second-Title-Primary">No Proppant Details Found.</div>
                                </td>
                            </tr>
                        ) : (
                            !runOrderLoading &&
                            !editStageSheetLoading &&
                            !isWeightEdit &&
                            proppantDetails.map((proppantDetail, index) => (
                                <tr key={index}>
                                    <td>{proppantDetail.proppantName}</td>
                                    <td
                                        className={
                                            proppantDetail.totalWeightNeeded && proppantDetail.totalWeightNeeded < 0
                                                ? 'Td-Red-Background'
                                                : ''
                                        }
                                    >
                                        <NumberFormat
                                            value={proppantDetail.totalWeightNeeded || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                    </td>
                                    <td>
                                        <NumberFormat
                                            value={proppantDetail.sandPumped || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                    </td>
                                    <td>
                                        <NumberFormat
                                            value={proppantDetail.totalBoxWeight || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                    </td>
                                </tr>
                            ))
                        )}

                        {!runOrderLoading &&
                            !editStageSheetLoading &&
                            isWeightEdit &&
                            proppantDetails.map((proppantDetail, index) => (
                                <StageSheetWeightEditMode
                                    key={index}
                                    proppantDetail={proppantDetail}
                                    stagesToEdit={stagesToEdit}
                                    setStagesToEdit={setStagesToEdit}
                                />
                            ))}
                    </tbody>
                </Table>
            </div>

            <div className="StageSheet-Edit-Container">
                {isStageSheetEdit === false && isWeightEdit == false && !isRevertMode ? (
                    <div>
                        <div className="StageSheet-Button-Container">
                            {isStartEndStageEnabled && showStartButton && showStartButton == true ? (
                                <button
                                    className={`StageSheet-Button`}
                                    onClick={() => {
                                        setShowStartStageModal(true);
                                    }}
                                >
                                    <i className="material-icons StageSheet-Icons">play_arrow</i>
                                    Start Stage
                                </button>
                            ) : (
                                <></>
                            )}

                            {isPauseResumeStageEnabled && showPauseButton && showPauseButton == true ? (
                                <button
                                    className={`StageSheet-Button`}
                                    onClick={() => {
                                        setShowPauseStageModal(true);
                                    }}
                                >
                                    <i className="material-icons StageSheet-Icons">pause</i>
                                    Pause Stage
                                </button>
                            ) : (
                                <></>
                            )}

                            {isPauseResumeStageEnabled && showResumeButton && showResumeButton == true ? (
                                <button
                                    className={`StageSheet-Button`}
                                    onClick={() => {
                                        setShowResumeStageModal(true);
                                    }}
                                >
                                    <i className="material-icons StageSheet-Icons">play_circle_outline</i>
                                    Resume Stage
                                </button>
                            ) : (
                                <></>
                            )}
                            {isStartEndStageEnabled && showEndButton && showEndButton == true ? (
                                <button
                                    className={`StageSheet-Button`}
                                    onClick={() => {
                                        setShowEndStageModal(true);
                                    }}
                                >
                                    <i className="material-icons StageSheet-Icons">stop</i>
                                    End Stage
                                </button>
                            ) : (
                                <></>
                            )}
                        </div>
                        <div className="StageSheet-Button-Container-For-Tab">
                            <Dropdown className="JobProfile-CenterToggleButton-Container">
                                <Dropdown.Toggle
                                    variant="link"
                                    id="dropdown-basic"
                                    className="JobProfile-CenterToggleButton JobProfile-CenterToggleButton-Container Stagesheet-Actions common-Actions"
                                >
                                    <span>Actions</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item>
                                        {isStartEndStageEnabled && showStartButton && showStartButton == true ? (
                                            <button
                                                className={`StageSheet-Dropdown-Button`}
                                                onClick={() => {
                                                    setShowStartStageModal(true);
                                                }}
                                            >
                                                <i className="material-icons StageSheet-Icons">play_arrow</i>
                                                Start Stage
                                            </button>
                                        ) : (
                                            <></>
                                        )}
                                    </Dropdown.Item>
                                    <Dropdown.Item>
                                        {isPauseResumeStageEnabled && showPauseButton && showPauseButton == true ? (
                                            <button
                                                className={`StageSheet-Dropdown-Button`}
                                                onClick={() => {
                                                    setShowPauseStageModal(true);
                                                }}
                                            >
                                                <i className="material-icons StageSheet-Icons">pause</i>
                                                Pause Stage
                                            </button>
                                        ) : (
                                            <></>
                                        )}
                                    </Dropdown.Item>
                                    <Dropdown.Item>
                                        {isPauseResumeStageEnabled && showResumeButton && showResumeButton == true ? (
                                            <button
                                                className={`StageSheet-Dropdown-Button`}
                                                onClick={() => {
                                                    setShowResumeStageModal(true);
                                                }}
                                            >
                                                <i className="material-icons StageSheet-Icons">play_circle_outline</i>
                                                Resume Stage
                                            </button>
                                        ) : (
                                            <></>
                                        )}
                                    </Dropdown.Item>
                                    <Dropdown.Item>
                                        {isStartEndStageEnabled && showEndButton && showEndButton == true ? (
                                            <button
                                                className={`StageSheet-Dropdown-Button`}
                                                onClick={() => {
                                                    setShowEndStageModal(true);
                                                }}
                                            >
                                                <i className="material-icons StageSheet-Icons">stop</i>
                                                End Stage
                                            </button>
                                        ) : (
                                            <></>
                                        )}
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                ) : (
                    <></>
                )}

                <div className="StageSheet-Edit-Revert-Container">
                    {isEditStageSheetEnabled && (
                        <div>
                            {!isStageSheetEdit ? (
                                stageSheets.length !== 0 &&
                                !isWeightEdit &&
                                !isRevertMode && (
                                    <div className="StageSheet-Edit-Button-Container">
                                        <div className="StageSheet-Edit-Button" onClick={() => handleOnClickEdit()}>
                                            <i className="material-icons StageSheet-Edit-Icon">edit</i>
                                            Edit
                                        </div>
                                    </div>
                                )
                            ) : (
                                <div className="StageSheet-Cancel-Save-Button">
                                    <CustomButton title="Cancel" isBordered onClick={() => handleOnClickCancelEdit()} />
                                    <div className="StageSheet-Save-Button">
                                        <CustomButton
                                            title="Save"
                                            onClick={() => {
                                                handleOnSaveEdit();
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {isRevertStageSheetEnabled && showRevert && !revertStageSheetLoading && (
                        <div>
                            {!isRevertMode ? (
                                !isStageSheetEdit &&
                                !isWeightEdit && (
                                    <div className="StageSheet-Edit-Button-Container">
                                        <div className="StageSheet-Edit-Button" onClick={() => handleOnClickRevert()}>
                                            <i className="material-icons StageSheet-Edit-Icon">replay</i>
                                            Revert
                                        </div>
                                    </div>
                                )
                            ) : (
                                <div className="StageSheet-Cancel-Save-Button">
                                    <CustomButton
                                        title="Cancel"
                                        isBordered
                                        onClick={() => handleOnClickCancelRevert()}
                                    />
                                    <div className="StageSheet-Save-Button">
                                        <CustomButton
                                            title="Save"
                                            onClick={() => {
                                                handleOnSaveRevert();
                                            }}
                                            isDisabled={revertStageSheetLoading}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* For Laptop */}
            {stageSheetLoading || runOrderLoading || editStageSheetLoading || revertStageSheetLoading ? (
                <div className="StageSheet-Grid-Container StageSheet-Container">
                    <Table striped bordered className="tabletest StageSheet-Grid">
                        <thead>
                            <tr>
                                <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Station #</th>
                                <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Box</th>
                                <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Box Wt.</th>
                                <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Box Wt. Remaining</th>
                                <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Type</th>
                                <th className="StageSheet-Grid-Lg StageSheet-Grid-Header">Pad Location</th>
                                <th className="StageSheet-Grid-XLg StageSheet-Grid-Header">Box Action</th>
                                <th className="StageSheet-Grid-Lg StageSheet-Grid-Header">PO #</th>
                                <th className="StageSheet-Grid-Lg StageSheet-Grid-Header">Origin #</th>

                                <th className="StageSheet-Grid-Md StageSheet-Grid-Header">Load#</th>
                                <th className="StageSheet-Grid-Md StageSheet-Grid-Header">Sand Ticket #</th>
                                <th className="StageSheet-Grid-Md StageSheet-Grid-Header StageSheet-Grid-Wt">
                                    ST Weight
                                </th>
                                <th className="StageSheet-Grid-Md StageSheet-Grid-Header StageSheet-Grid-Wt">
                                    ST Wt. Remaining
                                </th>
                                {/* <th className="StageSheet-Grid-XLg StageSheet-Grid-Header">Action</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <div className="StageSheet-StageSheet-Spinner-Container">
                                <Loading />
                            </div>
                        </tbody>
                    </Table>
                </div>
            ) : (
                <div className="StageSheet-Grid-Container StageSheet-Container">
                    <DragDropContext onDragEnd={results => handleDragEnd(results)}>
                        <Table striped bordered className="tabletest StageSheet-Grid">
                            <thead>
                                <tr>
                                    <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Station #</th>
                                    <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Box</th>
                                    <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Box Wt.</th>
                                    <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Box Wt. Remaining</th>
                                    <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Type</th>
                                    <th className="StageSheet-Grid-Lg StageSheet-Grid-Header">Pad Location</th>
                                    <th className="StageSheet-Grid-XLg StageSheet-Grid-Header">Box Action</th>
                                    <th className="StageSheet-Grid-Lg StageSheet-Grid-Header">PO #</th>
                                    <th className="StageSheet-Grid-Lg StageSheet-Grid-Header">Origin #</th>

                                    <th className="StageSheet-Grid-Md StageSheet-Grid-Header">Load#</th>
                                    <th className="StageSheet-Grid-Md StageSheet-Grid-Header">Sand Ticket #</th>
                                    <th className="StageSheet-Grid-Md StageSheet-Grid-Header StageSheet-Grid-Wt">
                                        ST Weight
                                    </th>
                                    <th className="StageSheet-Grid-Md StageSheet-Grid-Header StageSheet-Grid-Wt">
                                        ST Wt. Remaining
                                    </th>
                                    {/* <th className="StageSheet-Grid-XLg StageSheet-Grid-Header">Action</th> */}
                                </tr>
                            </thead>

                            {stageSheetError && <Error error={stageSheetError} />}

                            {!stageSheetLoading && stageSheets.length === 0 ? (
                                <tbody>
                                    <tr>
                                        <td colSpan={10}>
                                            <div className="NoResult-Second-Title-Primary">
                                                No Box Details Available.
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                                <Droppable droppableId="tableBody">
                                    {(provided, snapshot) => (
                                        <tbody
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            className={snapshot.isUsingPlaceholder ? 'dragging' : undefined}
                                        >
                                            {!runOrderLoading &&
                                                !editStageSheetLoading &&
                                                !isStageSheetEdit &&
                                                !isRevertMode &&
                                                stageSheets.map((stageSheet, index) => (
                                                    <>
                                                        {stageSheet.stageSheetBellyDump?.map((load, loadIndex) => (
                                                            <Draggable
                                                                draggableId={`${stageSheet.stageSheetBoxId}-${loadIndex}`}
                                                                key={`${stageSheet.stageSheetBoxId}-${loadIndex}`}
                                                                index={index}
                                                                isDragDisabled={isDragDisabled}
                                                            >
                                                                {provided => (
                                                                    <tr
                                                                        key={`${stageSheet.stageSheetBoxId}-${loadIndex}`}
                                                                        className={`${parseInt(
                                                                            snapshot.draggingFromThisWith ?? '',
                                                                            10,
                                                                        ) === stageSheet.stageSheetBoxId && 'draggingRow'}`}
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        >
                                                                        {loadIndex === 0 && (
                                                                        <>
                                                                            <td rowSpan={stageSheet.stageSheetBellyDump?.length}
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellSm'}`}
                                                                        >
                                                                            {stageSheet.station === '0'
                                                                                ? ''
                                                                                : stageSheet.station}
                                                                        </td>
                                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellSm'}`}
                                                                        >
                                                                            <div className="StageSheet-GreenDot-Container">
                                                                                {stageSheet.boxDesc}
                                                                                {stageSheet.isPartial === 'Yes' && (
                                                                                    <div className="StageSheet-GreenDot" />
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellSm'}`}
                                                                        >
                                                                            <NumberFormat
                                                                                value={stageSheet.boxWeight || 0}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                            />
                                                                        </td>
                                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellMd'}`}
                                                                        >
                                                                            <NumberFormat
                                                                                value={stageSheet.boxWeightRemaining || 0}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                            />
                                                                        </td>
                                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellLg'}`}
                                                                        >
                                                                            {stageSheet.proppant}
                                                                        </td>
                                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellLg'}`}
                                                                        >
                                                                            {stageSheet.location}
                                                                        </td>
                                                                        
                                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}
                                                                            className={`StageSheet-Buttons-td ${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellXLg'}`}
                                                                        >
                                                                            {stageSheet.isOOS ? (
                                                                                <div className="StageSheet-Buttons-Container">
                                                                                    Out of Service
                                                                                </div>
                                                                            ) : (
                                                                                <div className="StageSheet-Buttons-Container">
                                                                                    <button
                                                                                        className="StageSheet-Buttons"
                                                                                        onClick={() =>
                                                                                            handleOnClickButton(
                                                                                                'OOS',
                                                                                                stageSheet.boxDesc,
                                                                                                stageSheet.stageSheetBoxId,
                                                                                                stageSheet.boxWeightRemaining,
                                                                                                stageSheet.boxWeight ===
                                                                                                stageSheet.currentProppantWeight,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        OOS
                                                                                    </button>
                                                                                    {stageSheet.boxWeightRemaining &&
                                                                                        stageSheet.boxWeight &&
                                                                                        stageSheet.boxWeightRemaining == 0 &&
                                                                                        stageSheet.boxWeight >
                                                                                        stageSheet.boxWeightRemaining ? (
                                                                                        <></>
                                                                                    ) : (
                                                                                        <>
                                                                                            {' '}
                                                                                            {stageSheet.boxWeightRemaining &&
                                                                                                stageSheet.boxWeight &&
                                                                                                stageSheet.boxWeightRemaining ==
                                                                                                stageSheet.boxWeight ? (
                                                                                                <>
                                                                                                    <button
                                                                                                        className="StageSheet-Buttons"
                                                                                                        onClick={() =>
                                                                                                            handleOnClickPartial(
                                                                                                                stageSheet,
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        Partial
                                                                                                    </button>
                                                                                                    <button
                                                                                                        className="StageSheet-Buttons"
                                                                                                        onClick={() =>
                                                                                                            handleOnClickDeleteButton(
                                                                                                                stageSheet.stageSheetBoxId,
                                                                                                                stageSheet.boxDesc,
                                                                                                                stageSheet.proppantId,
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        Delete
                                                                                                    </button>
                                                                                                    <button
                                                                                                        className="StageSheet-Buttons"
                                                                                                        onClick={() =>
                                                                                                            handleOnClickButton(
                                                                                                                'empty',
                                                                                                                stageSheet.boxDesc,
                                                                                                                stageSheet.stageSheetBoxId,
                                                                                                                stageSheet.boxWeight,
                                                                                                                stageSheet.boxWeight ===
                                                                                                                stageSheet.currentProppantWeight,
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        Empty
                                                                                                    </button>
                                                                                                </>
                                                                                            ) : (
                                                                                                <></>
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellMd'}`}
                                                                        >
                                                                            {stageSheet.sandPo}
                                                                        </td>
                                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellMd'}`}
                                                                        >
                                                                            {stageSheet.lofaOrigin}
                                                                        </td>
                                                                            </>
                                                                    )}
                                                                        
                                                                        <td
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellMd'}`}
                                                                        >
                                                                            {load?.loadId}
                                                                        </td>
                                                                        <td
                                                                            className={`StageSheet-Buttons-Link ${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellMd'}`}
                                                                            onClick={() =>
                                                                                load?.sandTicketLink
                                                                                    ? handleOnClickSandTicket(
                                                                                          load?.sandTicketLink,
                                                                                          load?.sandTicket,
                                                                                      )
                                                                                    : handleOnClickSandTicket(
                                                                                          stageSheet.sandTicketLink,
                                                                                          stageSheet.sandTicket,
                                                                                      )
                                                                            }
                                                                        >
                                                                            {load?.sandTicket ? load.sandTicket : stageSheet.sandTicket}
                                                                        </td>
                                                                        <td
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellMd'}`}
                                                                        >
                                                                            <NumberFormat
                                                                                value={load?.sandTicketWeight || 0}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                            />
                                                                        </td>
                                                                        <td
                                                                            className={`${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellMd'}`}
                                                                        >
                                                                            <NumberFormat
                                                                                value={load?.sandTicketWeightRemaining || 0}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                            />
                                                                        </td>
                                                                        {/* <td
                                                                            className={`StageSheet-Buttons-td ${parseInt(
                                                                                snapshot.draggingFromThisWith ?? '', 10
                                                                            ) === stageSheet.stageSheetBoxId &&
                                                                                'draggingRowCellXLg'}`}
                                                                        >
                                                                            {stageSheet.isOOS ? (
                                                                                <div className="StageSheet-Buttons-Container">
                                                                                    Out of Service
                                                                                    {isRevertStageSheetEnabled && (
                                                                                        <button
                                                                                            className="StageSheet-Buttons"
                                                                                            onClick={() =>
                                                                                                handleOnClickEditLoadWeight(
                                                                                                    stageSheet,
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Edit Delivered Wt
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            ) : (
                                                                                <div className="StageSheet-Buttons-Container">
                                                                                    {isRevertStageSheetEnabled && (
                                                                                        <button
                                                                                            className="StageSheet-Buttons"
                                                                                            onClick={() =>
                                                                                                handleOnClickEditLoadWeight(
                                                                                                    stageSheet,
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Edit Delivered Wt
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </td> */}
                                                                    </tr>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                    </>
                                                    
                                                ))}
                                            {provided.placeholder}
                                        </tbody>
                                    )}
                                </Droppable>
                            )}

                            <tbody>
                                {!runOrderLoading &&
                                    !editStageSheetLoading &&
                                    isStageSheetEdit &&
                                    stageSheets.map((stageSheet, index) => (
                                        
                                        <StageSheetBellyDumpEditMode
                                            key={index}
                                            stageSheet={stageSheet}
                                            stagesToEdit={stagesToEdit}
                                            setStagesToEdit={setStagesToEdit}
                                            isRevertStageSheetEnabled={isRevertStageSheetEnabled}
                                        />
                                    ))}
                            </tbody>

                            <tbody>
                                {!runOrderLoading &&
                                    !editStageSheetLoading &&
                                    isRevertMode &&
                                    stageSheets.map((stageSheet, index) => (
                                        <StageSheetBellyDumpRevertMode
                                            key={index}
                                            stageSheet={stageSheet}
                                            setStagesToRevert={setStagesToRevert}
                                            stagesToRevert={stagesToRevert}
                                            weightInvalidErrorList={weightInvalidErrorList}
                                            setWeightInvalidErrorList={setWeightInvalidErrorList}
                                            weightZeroErrorList={weightZeroErrorList}
                                            setWeightZeroErrorList={setWeightZeroErrorList}
                                            weightRemainingInvalidErrorList={weightRemainingInvalidErrorList}
                                            setWeightRemainingInvalidErrorList={setWeightRemainingInvalidErrorList}
                                            weightRemainingErrorList={weightRemainingErrorList}
                                            setWeightRemainingErrorList={setWeightRemainingErrorList}
                                            isRevertStageSheetEnabled={isRevertStageSheetEnabled}
                                        />
                                    ))}
                            </tbody>
                        </Table>
                    </DragDropContext>
                </div>
            )}

            {/* For tablet */}
            {stageSheetLoading || runOrderLoading || editStageSheetLoading || revertStageSheetLoading ? (
                <div className="StageSheet-Container-For-Tab">
                    <div className="StageSheet-StageSheet-Spinner-Container">
                        <Loading />
                    </div>
                </div>
            ) : (
                <div className="StageSheet-Container-For-Tab">
                    <DragDropContext onDragEnd={results => handleDragEnd(results)}>
                        {stageSheetError && <Error error={stageSheetError} />}

                        {!stageSheetLoading && (!stageSheets || stageSheets.length === 0) ? (
                            <div className="NoResult-Second-Title-Primary">No Box Details Available.</div>
                        ) : (
                            <Droppable droppableId="tableBody">
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        className={snapshot.isUsingPlaceholder ? 'dragging' : undefined}
                                    >
                                        {!runOrderLoading &&
                                            !editStageSheetLoading &&
                                            !isStageSheetEdit &&
                                            !isRevertMode &&
                                            stageSheets.map((stageSheet, index) => (
                                                <Draggable
                                                    draggableId={`${stageSheet.stageSheetBoxId}`}
                                                    key={`${stageSheet.stageSheetBoxId}`}
                                                    index={index}
                                                    isDragDisabled={isDragDisabled}
                                                >
                                                    {provided => (
                                                        <div
                                                            key={stageSheet.stageSheetBoxId}
                                                            className="StageSheet-Tab-Item-Container"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <div className="StageSheet-Tab-Item">
                                                                <div className="StageSheet-KeyValues">
                                                                    <span className="StageSheet-Key">Station #:</span>
                                                                    <span className="StageSheet-Value">
                                                                        {stageSheet.station === '0'
                                                                            ? ''
                                                                            : stageSheet.station}
                                                                    </span>
                                                                </div>
                                                                <div className="StageSheet-KeyValues">
                                                                    <span className="StageSheet-Key">PO #:</span>
                                                                    <span className="StageSheet-Value">
                                                                        {stageSheet.sandPo}
                                                                    </span>
                                                                </div>
                                                                <div className="StageSheet-KeyValues">
                                                                    <span className="StageSheet-Key">
                                                                        Box Wt:
                                                                    </span>
                                                                    <span className="StageSheet-Value">
                                                                        <NumberFormat
                                                                            value={stageSheet.boxWeight || 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </span>
                                                                </div>
                                                                
                                                                {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                                                                    <div key={idx} className="StageSheet-KeyValues">
                                                                        <span className="StageSheet-Key">Ticket {idx + 1} :</span>
                                                                        <span
                                                                        className="StageSheet-Value StageSheet-Buttons-Link"
                                                                        onClick={() =>
                                                                            handleOnClickSandTicket(
                                                                                load?.sandTicketLink,
                                                                                load?.sandTicket,
                                                                            )
                                                                        }
                                                                    >
                                                                        {load?.sandTicket}
                                                                    </span>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            <div className="StageSheet-Tab-Item StageSheet-Tab-Item-Lg">
                                                                <div className="StageSheet-KeyValues">
                                                                    <span className="StageSheet-Key">Origin :</span>
                                                                    <span className="StageSheet-Value">
                                                                        {stageSheet.lofaOrigin}
                                                                    </span>
                                                                </div>
                                                                
                                                                <div className="StageSheet-KeyValues">
                                                                    <span className="StageSheet-Key">
                                                                        Pad Location:
                                                                    </span>
                                                                    <span className="StageSheet-Value">
                                                                        {stageSheet.location}
                                                                    </span>
                                                                </div>
                                                                <div className="StageSheet-KeyValues">
                                                                    <span className="StageSheet-Key">
                                                                        Box Wt Remaining:
                                                                    </span>
                                                                    <span className="StageSheet-Value">
                                                                        <NumberFormat
                                                                            value={stageSheet.boxWeightRemaining || 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </span>
                                                                </div>
                                                                {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                                                                    <div key={idx} className="StageSheet-KeyValues">
                                                                        <span className="StageSheet-Key">St Wt/ St Wt Remaining:</span>
                                                                        <span className="StageSheet-Value">
                                                                            <NumberFormat
                                                                                value={load?.sandTicketWeight || 0}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                            />
                                                                            /
                                                                            <NumberFormat
                                                                                value={load?.sandTicketWeightRemaining || 0}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            <div className="StageSheet-Tab-Item">
                                                                <div className="StageSheet-KeyValues">
                                                                    <span className="StageSheet-Key">Box:</span>
                                                                    <span className="StageSheet-Value">
                                                                        <div className="StageSheet-GreenDot-Container">
                                                                            {stageSheet.boxDesc}
                                                                            {stageSheet.isPartial === 'Yes' && (
                                                                                <div className="StageSheet-GreenDot" />
                                                                            )}
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                                
                                                                <div className="StageSheet-KeyValues">
                                                                    <span className="StageSheet-Key">Type:</span>
                                                                    <span className="StageSheet-Value">
                                                                        {stageSheet.proppant}
                                                                    </span>
                                                                </div>
                                                                <br />
                                                                
                                                                {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                                                                    <div key={idx} className="StageSheet-KeyValues">
                                                                        <span className="StageSheet-Key">Load {idx + 1} #:</span>
                                                                        <span className="StageSheet-Value">
                                                                        {load?.loadId || 0}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            {stageSheet.isOOS ? (
                                                                <div className="StageSheet-Tab-Button-Item">
                                                                    Out of Service
                                                                    {/* {isRevertStageSheetEnabled && (
                                                                        <button
                                                                            className="StageSheet-Buttons-For-Tab StageSheet-LoadWeight-Buttons-For-Tab"
                                                                            onClick={() =>
                                                                                handleOnClickEditLoadWeight(stageSheet)
                                                                            }
                                                                        >
                                                                            Edit Delivered Wt
                                                                        </button>
                                                                    )} */}
                                                                </div>
                                                            ) : (
                                                                <div className="StageSheet-Tab-Button-Item">
                                                                    <button
                                                                        className="StageSheet-Buttons-For-Tab"
                                                                        onClick={() =>
                                                                            handleOnClickButton(
                                                                                'OOS',
                                                                                stageSheet.boxDesc,
                                                                                stageSheet.stageSheetBoxId,
                                                                                stageSheet.boxWeightRemaining,
                                                                                stageSheet.boxWeight ===
                                                                                stageSheet.currentProppantWeight,
                                                                            )
                                                                        }
                                                                    >
                                                                        OOS
                                                                    </button>
                                                                    {stageSheet.boxWeightRemaining &&
                                                                        stageSheet.boxWeight &&
                                                                        stageSheet.boxWeightRemaining == 0 &&
                                                                        stageSheet.boxWeight >
                                                                        stageSheet.boxWeightRemaining ? (
                                                                        <></>
                                                                    ) : (
                                                                        <>
                                                                            {stageSheet.boxWeightRemaining &&
                                                                                stageSheet.boxWeight &&
                                                                                stageSheet.boxWeightRemaining ==
                                                                                stageSheet.boxWeight ? (
                                                                                <>
                                                                                    <button
                                                                                        className="StageSheet-Buttons-For-Tab"
                                                                                        onClick={() =>
                                                                                            handleOnClickPartial(
                                                                                                stageSheet,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Partial
                                                                                    </button>
                                                                                    <button
                                                                                        className="StageSheet-Buttons-For-Tab"
                                                                                        onClick={() =>
                                                                                            handleOnClickDeleteButton(
                                                                                                stageSheet.stageSheetBoxId,
                                                                                                stageSheet.boxDesc,
                                                                                                stageSheet.proppantId,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Delete
                                                                                    </button>
                                                                                    <button
                                                                                        className="StageSheet-Buttons-For-Tab"
                                                                                        onClick={() =>
                                                                                            handleOnClickButton(
                                                                                                'empty',
                                                                                                stageSheet.boxDesc,
                                                                                                stageSheet.stageSheetBoxId,
                                                                                                stageSheet.boxWeight,
                                                                                                stageSheet.boxWeight ===
                                                                                                stageSheet.currentProppantWeight,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Empty
                                                                                    </button>
                                                                                </>
                                                                            ) : (
                                                                                <></>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {/* {isRevertStageSheetEnabled && (
                                                                        <button
                                                                            className="StageSheet-Buttons-For-Tab StageSheet-LoadWeight-Buttons-For-Tab"
                                                                            onClick={() =>
                                                                                handleOnClickEditLoadWeight(stageSheet)
                                                                            }
                                                                        >
                                                                            Edit Delivered Wt
                                                                        </button>
                                                                    )} */}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        )}

                        {!runOrderLoading &&
                            !editStageSheetLoading &&
                            isStageSheetEdit &&
                            !isRevertMode &&
                            stageSheets.map((stageSheet, index) => (
                                <StageSheetBellyDumpEditMode
                                    key={index}
                                    stageSheet={stageSheet}
                                    stagesToEdit={stagesToEdit}
                                    setStagesToEdit={setStagesToEdit}
                                    isRevertStageSheetEnabled={isRevertStageSheetEnabled}
                                />
                            ))}

                        {!runOrderLoading &&
                            !editStageSheetLoading &&
                            isRevertMode &&
                            stageSheets.map((stageSheet, index) => (
                                <StageSheetBellyDumpRevertMode
                                    key={index}
                                    stageSheet={stageSheet}
                                    setStagesToRevert={setStagesToRevert}
                                    stagesToRevert={stagesToRevert}
                                    weightInvalidErrorList={weightInvalidErrorList}
                                    setWeightInvalidErrorList={setWeightInvalidErrorList}
                                    weightZeroErrorList={weightZeroErrorList}
                                    setWeightZeroErrorList={setWeightZeroErrorList}
                                    weightRemainingInvalidErrorList={weightRemainingInvalidErrorList}
                                    setWeightRemainingInvalidErrorList={setWeightRemainingInvalidErrorList}
                                    weightRemainingErrorList={weightRemainingErrorList}
                                    setWeightRemainingErrorList={setWeightRemainingErrorList}
                                    isRevertStageSheetEnabled={isRevertStageSheetEnabled}
                                />
                            ))}
                    </DragDropContext>
                </div>
            )}

            {showSendEmailModal && (
                <SendEmailModal
                    show={showSendEmailModal}
                    onClickHide={handleOnCloseEmailModal}
                    textMessage={sendEmailMsg}
                />
            )}
            {showStageSheetModal && (
                <StageSheetModal
                    showStageSheetModal={showStageSheetModal}
                    modalType={modalType}
                    isPartial={isPartial}
                    stageSheetBoxId={stageSheetBoxId}
                    stageSheetBox={stageSheetBox}
                    sandTicket={sandTicket}
                    weight={boxWeight}
                    sandTicketNumber={sandTicketNumber}
                    handleOnClose={handleOnCloseModal}
                    handleOnSave={handleOnSave}
                    mutationLoading={mutationLoading}
                    mutationError={modalError}
                />
            )}

            {showStageSheetDeleteModal && (
                <StageSheetDeleteModal
                    showStageSheetDeleteModal={showStageSheetDeleteModal}
                    jobId={jobId}
                    stageSheetBoxId={stageSheetBoxId}
                    stageSheetBox={stageSheetBox}
                    handleOnClose={handleOnCloseModal}
                    handleOnSave={handleOnClickDelete}
                    mutationLoading={deleteMutationLoading}
                    mutationError={modalError}
                />
            )}

            {showStageSheetPartialModal && boxForPartial && (
                <StageSheetPartialModal
                    jobId={jobId}
                    stageSheetId={parseInt(stageSheetIdVal)}
                    showStageSheetPartialModal={showStageSheetPartialModal}
                    stageSheet={boxForPartial}
                    handleOnClose={handleOnClosePartialModal}
                    handleOnSave={handleOnSavePartialModal}
                    mutationLoading={allocatePartialLoading}
                    modalError={modalError}
                    setModalError={setModalError}
                />
            )}

            {showStartStageModal && (
                <StartStageModal
                    showStartStageModal={showStartStageModal}
                    stageNumbers={stageNumbers}
                    stageMsgNumbers={stageMsgNumbers}
                    stageStatusData={stageStatusData}
                    jobId={jobId}
                    jobLogRootCauses={jobLogsRootCausesData}
                    jobLogLocationLofa={jobLogsLocationLofaData}
                    handleOnClose={handleOnCloseStageModal}
                    handleOnSave={handleOnStartStages}
                    mutationLoading={startStagesLoading}
                    modalError={stageModalError}
                    setModalError={setStageModalError}
                />
            )}
            {showEndStageModal && (
                <EndStageModal
                    showEndStageModal={showEndStageModal}
                    stageStatusData={stageStatusData}
                    handleOnClose={handleOnCloseStageModal}
                    handleOnSave={handleOnEndStages}
                    mutationLoading={endStagesLoading}
                    mutationError={stageModalError}
                />
            )}
            {showPauseStageModal && (
                <PauseStageModal
                    showPauseStageModal={showPauseStageModal}
                    jobLogsTypesData={jobLogsTypesData}
                    jobLogIssues={jobLogsIssuesData}
                    jobLogLocationLofa={jobLogsLocationLofaData}
                    jobLogRootCauses={jobLogsRootCausesData}
                    stageStatusData={stageStatusData}
                    handleOnClose={handleOnCloseStageModal}
                    handleOnSave={handleOnPauseStages}
                    mutationLoading={pauseStagesLoading}
                    mutationError={stageModalError}
                />
            )}
            {showResumeStageModal && (
                <ResumeStageModal
                    showResumeStageModal={showResumeStageModal}
                    stageStatusData={stageStatusData}
                    jobId={jobId}
                    jobLogLocationLofa={jobLogsLocationLofaData}
                    jobLogRootCauses={jobLogsRootCausesData}
                    handleOnClose={handleOnCloseStageModal}
                    handleOnSave={handleOnResumeStages}
                    mutationLoading={resumeStagesLoading}
                    modalError={stageModalError}
                    setModalError={setStageModalError}
                />
            )}

            {showEditLoadWeightModal && stageSheetToEditWeight && (
                <StageSheetEditLoadWeightModal
                    jobId={jobId}
                    showModal={showEditLoadWeightModal}
                    stageSheet={stageSheetToEditWeight}
                    handleOnClose={handleOnClickCancelEditLoadWeight}
                    handleOnSave={handleOnSaveEditLoadWeight}
                    mutationError={stageModalError}
                    mutationLoading={updateBoxWeightLoading || updateInventoryWeightLoading}
                />
            )}

            <div className="StageSheet-Layout-To-print">
                <StageSheetPrintForkliftLayout
                    innerRef={printForkliftcomponentRef}
                    jobName={jobName ?? ''}
                    wellheadStages={wellheadStages ?? ''}
                    proppantDetails={proppantDetails}
                    stageSheets={stageSheets}
                />
                <StageSheetBellyDumpPrintAllLayout
                    innerRef={printAllBellyDumpComponentRef}
                    wellheadStages={wellheadStages ?? ''}
                    jobName={jobName ?? ''}
                    proppantDetails={proppantDetails}
                    stageSheets={stageSheets}
                />
            </div>
        </div>
    );
};

export default StageSheetBellyDump;
